import React from 'react';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { Title } from '@/components/typography';
import { Button } from '@/components/button';
import { paths } from '@/config/url';
import { InnerElement } from '@/components/cta/CreateJourney/CreateJourney.styles';
import { VisibilityBreakpointType } from '@/styles/utilities';

export interface CreateJourneyProps extends VisibilityBreakpointType {
  size?: 'default' | 'large';
}

const CreateJourney = ({ size, ...props }: CreateJourneyProps) => {
  return (
    <WhitePaper {...props}>
      <InnerElement size={size}>
        <Title as="h4" size={size === 'large' ? 'md' : 'base'}>
          Não encontrou a viagem que procurava?
        </Title>
        <Button appearance="primary" size="large" href={paths.form_create_journey}>
          CRIE SEU ROTEIRO
        </Button>
      </InnerElement>
    </WhitePaper>
  );
};

export default CreateJourney;
